import { createZustandStore } from '../../../zustand';

import { DEFAULT_SCAN_TYPE } from '../remove-package';

import { IInboundState } from './types';

/**
 * This creates a local global state for Inbound selected filters and update the
 * filters
 * TODO: Migrate search specific filters to `useSearchPackageStore`
 * Here is a story for this: https://northladder.atlassian.net/browse/ELC-11748
 */
export const useCreateInboundStore = createZustandStore<IInboundState>()(
  (set) => ({
    searchKey: '',
    selectedBoxIdentifier: '',
    updateSearchKey: (searchKey) => set(() => ({ searchKey })),
    specificFieldFilter: null,
    specificKeywordFilter: [],
    updateSpecificFieldFilter: (field) =>
      set(() => ({ specificFieldFilter: field })),
    updateSpecificKeywordFilter: (keyword) =>
      set(() => ({ specificKeywordFilter: keyword })),
    inboundDetails: null,
    updateInboundDetails: (inboundDetails) => set(() => ({ inboundDetails })),
    driverSignature: null,
    updateDriverSignature: (driverSignature) =>
      set(() => ({ driverSignature })),
    packageDetails: null,
    updatePackageDetails: (packageDetails) => set(() => ({ packageDetails })),
    currentScanStep: 'scanPackage',
    packageIdentifier: '',
    suggestedTrayInfo: null,
    updateSuggestedTrayInfo: (suggestedTrayInfo) =>
      set(() => ({ suggestedTrayInfo })),
    updateCurrentScanStep: (currentScanStep) =>
      set(() => ({ currentScanStep })),
    updateIsScannerReadingData: (isScannerReadingData) =>
      set(() => ({ isScannerReadingData })),
    isScannerReadingData: false,
    scanType: DEFAULT_SCAN_TYPE,
    updatePackageIdentifier: (packageIdentifier) =>
      set(() => ({ packageIdentifier })),
    updateScanType: (scanType) => set(() => ({ scanType })),
    transferPodInfo: null,
    updateTransferPodInfo: (transferPodInfo) =>
      set(() => ({ transferPodInfo })),
    transferTrayInfo: null,
    updateTransferTrayInfo: (transferTrayInfo) =>
      set(() => ({ transferTrayInfo })),
    boxNumber: '',
    updateBoxNumber: (boxNumber) => set(() => ({ boxNumber })),
    updateSelectedBoxIdentifier: (identifier) =>
      set(() => ({ selectedBoxIdentifier: identifier })),
    isNDRScanScreenVisible: false,
    updateIsNDRScanScreenVisible: (visible) =>
      set(() => ({ isNDRScanScreenVisible: visible })),
    resetScanData: () =>
      set(() => ({
        packageDetails: null,
        transferPodInfo: null,
        transferTrayInfo: null,
        isPackageRemoved: false,
        currentScanStep: 'scanPackage',
        packageIdentifier: '',
        isNDRScanScreenVisible: false,
      })),
    inboundFlowCurrentStep: 'CREATE_INBOUND',
    updateCurrentInboundStep: (step) =>
      set(() => ({ inboundFlowCurrentStep: step })),
    inboundSortOrder: 'NEW',
    updateInboundSortOrder: (sortOrder) =>
      set(() => ({ inboundSortOrder: sortOrder })),
    inboundCalendarDateRange: null,
    updateInboundCalendarDateRange: (dateRange) =>
      set(() => ({ inboundCalendarDateRange: dateRange })),
    openInboundCalendarDateRange: null,
    openInboundSortOrder: 'NEW',
    openInboundSearchKey: '',
    openInboundSpecificFieldFilter: null,
    openInboundSpecificKeywordFilter: [],
    updateOpenInboundSearchKey: (openInboundSearchKey) =>
      set(() => ({ openInboundSearchKey })),
    updateOpenInboundSpecificFieldFilter: (field) =>
      set(() => ({ openInboundSpecificFieldFilter: field })),
    updateOpenInboundSpecificKeywordFilter: (keyword) =>
      set(() => ({ openInboundSpecificKeywordFilter: keyword })),
    updateOpenInboundSortOrder: (sortOrder) =>
      set(() => ({ openInboundSortOrder: sortOrder })),
    updateOpenInboundCalendarDateRange: (dateRange) =>
      set(() => ({ openInboundCalendarDateRange: dateRange })),
    resetStore: () =>
      set(() => ({
        currentScanStep: 'scanPackage',
        isPackageRemoved: false,
        isScannerReadingData: false,
        packageDetails: null,
        packageIdentifier: '',
        scanType: DEFAULT_SCAN_TYPE,
        selectedBoxIdentifier: '',
        transferPodInfo: null,
        transferTrayInfo: null,
        isNDRScanScreenVisible: false,
      })),
  })
);
